import React, { useState } from "react";
import { Table, Select, Input } from "antd";
import styles from "./AdminStaffMgmt.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  Modal,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { ReactComponent as ArchiveIcon } from "../../../../assets/images/archive.svg";

import { ReactComponent as EditIcon } from "../../../../assets/images/editIcon.svg";
const { Option } = Select;

const AdminStaffMgmt = () => {
  const navigate = useNavigate();
  const [isModal, setIsModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [staffList, setStaffList] = useState([
    {
      staffId: "STF-001",
      name: "Stephanie Doe",
      role: "Supervisor",
      department: "Assembly",
      status: "Active",
      action: "View",
    },
    {
      staffId: "STF-002",
      name: "John Smith",
      role: "Staff Member",
      department: "Oven",
      status: "Active",
      action: "Edit",
    },
    {
      staffId: "STF-003",
      name: "Michael Brown",
      role: "Supervisor",
      department: "Mixing",
      status: "Archived",
      action: "Archive",
    },
    {
      staffId: "STF-004",
      name: "Jessica Taylor",
      role: "Staff Member",
      department: "Assembly",
      status: "Archived",
      action: "Archive",
    },
    {
      staffId: "STF-005",
      name: "Robert Lee",
      role: "Supervisor",
      department: "Mixing",
      status: "Active",
      action: "View",
    },
    {
      staffId: "STF-006",
      name: "Emma Davis",
      role: "Staff Member",
      department: "Oven",
      status: "Archived",
      action: "View",
    },
  ]);
  const [showFilter, setShowFilter] = useState(false);
  const [role, setRole] = useState({
    value: "Admin",
    id: 1,
  });
  const [statuss, setStatus] = useState({
    value: "Active",
    id: 1,
  });
  const filteredStaff = staffList.filter(
    (staff) =>
      staff.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      staff.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
      staff.department.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const columns = [
    {
      title: "Staff ID",
      dataIndex: "staffId",
      key: "staffId",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",

    //   render: (text) => (
    //     <span
    //       className={
    //         text === "Active" ? styles.activeStatus : styles.archivedStatus
    //       }
    //     >
    //       {text}
    //     </span>
    //   ),
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",

      render: (text) => (
        <div className={styles.itemsButtonDiv}>
          <ViewIcon
            className={styles.itemsButton}
            onClick={() => navigate("/StaffDetails")}
          />

          <EditIcon
            className={styles.itemsButton}
            onClick={() => navigate("/AdminEditStaffUser")}
          />
          <ArchiveIcon
            className={styles.itemsButton}
            onClick={() => setIsModal(true)}
          />
        </div>
      ),
    },
  ];

  const StationOptions = [
    {
      value: "Mixing",
      id: 1,
    },
    {
      value: "Make Up",
      id: 2,
    },
    {
      value: "Proofing",
      id: 3,
    },
    {
      value: "Chilling",
      id: 4,
    },
    {
      value: "Oven",
      id: 5,
    },
    {
      value: "Assembly",
      id: 6,
    },
    {
      value: "Packaging",
      id: 7,
    },
  ];

  const [station, setStation] = useState(StationOptions[0]);

  const handleDisplayFilter = () => {
    setShowFilter(true);
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Staff Management"}
        showFilterIcon={true}
        onClickFilter={() => handleDisplayFilter()}
        onSearch={(e) => console.log(e.target.value)}
        onSubmit={() => navigate("/CreateNewStaffUser")}
        submitButtonText={" Create"}
        // showBackIcon={true}
        showSubmitButton={true}
        showSearch={true}
      />

      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={filteredStaff}
          pagination={false}
          rowKey="staffId"
        />
      </div>
      <Modal
        open={isModal}
        onClickOkButton={() => {
          setIsModal(false);
        }}
        onCancel={() => setIsModal(false)}
        className={styles.modalCont}
        title={"Archive"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setIsModal(false)}
        onClickCancelButton={() => setIsModal(false)}
        okBtnTitle={"Yes"}
        cancelBtnTitle={"No"}
      >
        <div>
          <TextComponent
            text="Are you sure you want to archive? "
            className={styles.CardText}
          />
        </div>
      </Modal>

      {/* fILTER MODAL  */}

      <Modal
        open={showFilter}
        onClickOkButton={() => {
          setShowFilter(false);
        }}
        onCancel={() => setShowFilter(false)}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        btnStyle={{ width: "200px", marginTop: "12px" }}
        twoButton
        onBtnPress={() => setShowFilter(false)}
        onClickCancelButton={() => setShowFilter(false)}
        okBtnTitle={"Apply Filters"}
        cancelBtnTitle={"Reset All"}
      >
        <Dropdown
          className={styles.input}
          label={"Role"}
          labelClass={styles.labelClass}
          value={role}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Supervisor",
              role: "supervisor",
              id: 1,
            },
            {
              value: "Staff Member",
              role: "staff",
              id: 2,
            },
          ]}
          onChange={(e) => setRole(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Station"}
          labelClass={styles.labelClass}
          value={station}
          style={{ color: "var(--black-color)" }}
          options={StationOptions}
          onChange={(e) => setStation(e)}
        />
        <Dropdown
          className={styles.input}
          label={"Status"}
          labelClass={styles.labelClass}
          value={statuss}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "Active",
              id: 1,
            },
            {
              value: "Archived",
              id: 2,
            },
          ]}
          onChange={(e) => setStatus(e)}
        />
      </Modal>
    </div>
  );
};

export default AdminStaffMgmt;
